/**
 * Extract a user-facing message from API error payloads.
 * Supports plain message/error/detail fields and ASP.NET ValidationProblemDetails:
 * { errors: { Password: ["..."] }, title, status, ... }
 */
export function extractApiErrorMessage(data, fallback = "") {
  if (data == null) return fallback;

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  if (typeof data !== "object") {
    return fallback;
  }

  if (typeof data.message === "string" && data.message.trim()) {
    return data.message.trim();
  }

  if (typeof data.error === "string" && data.error.trim()) {
    return data.error.trim();
  }

  if (typeof data.detail === "string" && data.detail.trim()) {
    return data.detail.trim();
  }

  if (data.errors && typeof data.errors === "object") {
    const messages = [];
    for (const value of Object.values(data.errors)) {
      if (Array.isArray(value)) {
        for (const item of value) {
          if (typeof item === "string" && item.trim()) {
            messages.push(item.trim());
          }
        }
      } else if (typeof value === "string" && value.trim()) {
        messages.push(value.trim());
      }
    }
    if (messages.length) {
      return [...new Set(messages)].join(" — ");
    }
  }

  if (typeof data.title === "string" && data.title.trim()) {
    return data.title.trim();
  }

  return fallback;
}

export function extractAxiosErrorMessage(error, fallback = "") {
  const fromBody = extractApiErrorMessage(error?.response?.data, "");
  if (fromBody) return fromBody;
  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message.trim();
  }
  return fallback;
}
